import { ReactNode } from 'react';

export interface RiskWidgetCardProps {
  // A RiskBanner element (or falsy); the card only rounds its bottom corners when a banner claims the top.
  banner?: ReactNode;
  children: ReactNode;
  // Grow the dark card to fill a stretched flex-column parent (used to height-match a sibling card).
  fill?: boolean;
}

// Shared shell for the risk widget family: an optional tier banner flush above the dark summary card.
export const RiskWidgetCard = ({ banner, children, fill }: RiskWidgetCardProps) => (
  <>
    {banner}
    <div className={`bg-[#333741] px-5 py-4 ${fill ? 'flex-1' : ''} ${banner ? 'rounded-b-lg' : 'rounded-lg'}`}>
      {children}
    </div>
  </>
);
